import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AbstractDynamicComponent } from '@components/abstracts';
import { PushEncartsVerts } from '@components/push-encarts-verts/models';
import { SvgComponent } from '@shared/components/svg';
import { TitleComponent } from '@shared/components/title';

@Component({
  selector: 'app-push-encarts-verts',
  templateUrl: './push-encarts-verts.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TitleComponent, SvgComponent, RouterLink],
})
export class PushEncartsVertsComponent extends AbstractDynamicComponent<PushEncartsVerts> {}
